import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
// import { Link } from 'react-router-dom'

import s from './Seighth.module.scss'

class Seighth extends React.PureComponent {
  static handleClick() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }
  constructor(props) {
    super(props)
    this.state = {
      // 初始state
      index: 0,
      opacity: 1,
      showAnimation: false
    }
    this._handleScroll = this.handleScroll.bind(this)
  }
  componentDidMount() {
    window.addEventListener('scroll', this._handleScroll)
    // 初始检查一次位置
    this._handleScroll()
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this._handleScroll)
  }
  handleScroll() {
    const clientHeight = document.documentElement.clientHeight
    const seighthRect = this.refs.Seighth.getBoundingClientRect()
    
    // 当元素的顶部进入视口60%时触发动画
    if (seighthRect.top < clientHeight * 0.8 && !this.state.showAnimation) {
      this.setState({ showAnimation: true })
    }
  }
  render() {
    const { showAnimation } = this.state
    
    return (
      <div
        className={s.Seighth}
        ref="Seighth"
      >
        <div className={`${s.wrap} `} ref="text">
          <div className={s.item1}>
            <div className={s.item1_title}>
              <FormattedMessage id="dk3_seven_item1_title" />
            </div>
            <div className={s.item1_desc}>
              <FormattedMessage id="dk3_seven_item1_desc" />
            </div>
          </div>
          <div className={s.item2}>
            <div className={`${s.title} ${showAnimation ? s.animateIn : s.hidden}`}>
              <FormattedMessage id="dk3_seven_title" values={{br: <br />}} />
            </div>
            <div className={s.item2_item}>
              <div className={s.item2_title}>
                <FormattedMessage id="dk3_seven_item2_title" />
              </div>
              <div className={s.item2_desc}>
                <FormattedMessage id="dk3_seven_item2_desc" />
              </div>
            </div>
          </div>
          <div className={s.item3}>
            <div className={s.item3_title}>
              <FormattedMessage id="dk3_seven_item3_title" />
            </div>
            <div className={s.item3_desc}>
              <FormattedMessage id="dk3_seven_item3_desc" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  locale: state.language,
})

const SEighth = connect(mapStateToProps)(Seighth)

export default SEighth
